export default __webpack_public_path__ + "static/media/edit-deactive.e04f38a4.svg";